import React from 'react'
import styled from 'styled-components'

type Props = {
  name: string
}

const MenuHeader = (props: Props) => {
  const { name } = props

  return (
    <Wrapper>
      <div className="step-header-padding">
        <div className="d-flex justify-content-between step-header">
          <span className="step-name">{name}</span>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  left: 0;
  top: 0;
  background-color: #ffffff;
  .step-header-padding {
    padding: 10px 20px;
    border-bottom: 2px solid #cfc392;
  }
  .step-name {
    font-weight: 400;
    padding-top: 2px;
    // padding-left: 10px;
    font-size: 18px;
  }
  .icon-close {
    height: 1rem;
    margin-top: 5px;
  }
`

export default MenuHeader
